import { SvgProps } from "@/utils/types";
import React from "react";

export const Apple = ({
  primaryColor = "#D4DF65",
  outlineColor = "#0E5654",
  className,
}: SvgProps) => (
  <svg
    width="42"
    height="49"
    viewBox="0 0 42 49"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <g clipPath="url(#clip0_5_874)">
      <path
        d="M20.69 44.97C20.69 44.97 22.71 46.88 26.53 46.88C36.09 46.88 43.25 25.86 37.2 18.37C31.15 10.88 20.62 17.1 20.62 17.1C20.62 17.1 10.23 10.89 4.18003 18.37C-1.86997 25.85 5.29004 46.88 14.85 46.88C18.67 46.88 20.69 44.97 20.69 44.97Z"
        fill={primaryColor}
      />
      <path
        d="M26.53 48.84C23.84 48.84 21.88 48.05 20.69 47.36C19.5 48.05 17.54 48.84 14.85 48.84C10.33 48.84 6.01003 45.24 3.01003 38.96C-0.309968 32.01 -1.49997 22.28 2.66003 17.15C7.87003 10.7 16.17 12.61 20.63 14.88C25.13 12.62 33.51 10.71 38.72 17.15C42.87 22.29 41.68 32.01 38.37 38.96C35.37 45.24 31.06 48.84 26.53 48.84ZM22.02 43.54C22.11 43.62 23.64 44.93 26.53 44.93C29.42 44.93 32.55 42.07 34.84 37.27C37.99 30.68 38.36 22.92 35.68 19.6C30.75 13.5 21.71 18.73 21.62 18.78C21 19.14 20.24 19.14 19.62 18.78C19.26 18.57 10.6 13.55 5.70003 19.6C3.02003 22.91 3.39003 30.67 6.54003 37.26C8.83003 42.05 11.93 44.92 14.85 44.92C17.77 44.92 19.3 43.58 19.36 43.53C20.11 42.86 21.27 42.85 22.01 43.53L22.02 43.54Z"
        fill={outlineColor}
      />
      <path
        d="M10.64 25.13C11.8827 25.13 12.89 24.1226 12.89 22.88C12.89 21.6374 11.8827 20.63 10.64 20.63C9.39737 20.63 8.39001 21.6374 8.39001 22.88C8.39001 24.1226 9.39737 25.13 10.64 25.13Z"
        fill={outlineColor}
      />
      <path
        d="M8.23001 25.72C8.23001 25.72 9.06001 26.86 10.97 26.57C10.97 26.57 9.50001 30.24 12.32 38.21C12.32 38.21 6.43001 33.77 8.23001 25.72Z"
        fill={outlineColor}
      />
      <path
        d="M20.68 18.48C19.68 18.48 18.82 17.71 18.73 16.69C17.94 7.70999 23.73 4.14999 23.98 3.99999C24.91 3.43999 26.11 3.74999 26.66 4.67999C27.21 5.59999 26.92 6.79999 26 7.34999C25.8 7.46999 22.07 9.93999 22.63 16.35C22.72 17.43 21.93 18.38 20.85 18.47C20.79 18.47 20.73 18.47 20.68 18.47V18.48Z"
        fill={outlineColor}
      />
      <path
        d="M16.57 6.73999C18.31 9.52999 17.42 14.69 17.42 14.69C17.42 14.69 12.39 13.23 10.65 10.44C8.90997 7.64999 9.79997 2.48999 9.79997 2.48999C9.79997 2.48999 14.83 3.94999 16.57 6.73999Z"
        fill={primaryColor}
      />
      <path
        d="M18.97 17.17L16.87 16.56C16.28 16.39 11.06 14.8 8.98 11.47C6.9 8.14 7.76 2.75 7.86 2.15L8.23 0L10.33 0.61C10.92 0.78 16.14 2.37 18.22 5.7C20.3 9.03 19.44 14.42 19.34 15.02L18.97 17.17ZM11.52 5.25C11.51 6.77 11.69 8.43 12.3 9.4C12.91 10.37 14.31 11.27 15.69 11.92C15.7 10.4 15.52 8.74 14.91 7.77C14.3 6.8 12.9 5.9 11.52 5.25Z"
        fill={outlineColor}
      />
    </g>
    <defs>
      <clipPath id="clip0_5_874">
        <rect width="41.37" height="48.84" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
